module.exports = __webpack_public_path__ + "assets/images/dado_86257f1c0d15d680e95d4b45d30958ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cubo/dado.png
// module id = 198
// module chunks = 0